<script setup lang="ts">
import { useCustomizerStore } from '@/stores/customizer';
const customizer = useCustomizerStore();
</script>
<template>
  <v-locale-provider>
    <v-app 
      class="login-layout"
      :theme="customizer.actTheme" 
      :class="[
                customizer.actTheme,
            ]">
      <NuxtPage />
    </v-app>
  </v-locale-provider>
</template>